import { Typography } from 'antd';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { DivInputStyle } from '../../../../../ui/form/DivInputStyle.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../common/util/getWidgetProps.ts';
import { type IAsyncValueWidget } from './IAsyncValueWidget.ts';

const { Text } = Typography;

export interface IAsyncValueWidgetPreviewProps
  extends IWidgetComponentProps<IAsyncValueWidget> {}

export function AsyncValueWidgetPreview(props: IAsyncValueWidgetPreviewProps) {
  const { widget } = props;
  const options = getWidgetProps(props);

  return (
    <ConfigFormItem
      name="string"
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={
        options.helpText ? (
          <RichTextAdvancedRender inline text={options.helpText} />
        ) : undefined
      }
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
      widget={props.widget}
    >
      <DivInputStyle>
        <Text style={{ minHeight: '1.5rem' }} type="secondary">
          {widget.notes}
        </Text>
      </DivInputStyle>
    </ConfigFormItem>
  );
}
